import { Component } from '@angular/core';
import { TenantSelectorComponent } from '../tenant-selector/tenant-selector.component';

/**
 * Compact header version of tenant selector
 * Displays only icon in collapsed state, full dropdown in header
 */
@Component({
  selector: 'app-tenant-selector-header',
  templateUrl: './tenant-selector-header.component.html',
  styleUrls: ['./tenant-selector-header.component.scss']
})
export class TenantSelectorHeaderComponent extends TenantSelectorComponent {
  // Inherits all logic from parent TenantSelectorComponent
  // Template provides compact header-specific layout
}
